export class OvertimeDeservedDto {
    id: number;
    employeeId: number;
    absenceType: number;
    unitOfInterval: string;
    deservedAmount: number;
    transferAmount: number;
    remainingAmount: number;
    startDate: string;
    endDate: string;
    totalUsedOvertimeAmount: number;

    constructor() {
        this.deservedAmount = 0;
        this.transferAmount = 0;
        this.remainingAmount = 0;
    }
}
